module.exports = __webpack_public_path__ + "img/hc_pro_six_4.243f5cd9.jpg";